export class vendor{
    _id:any;
    accountId:any;
    accountEmailId:any;
    vendorName:any;
    vendorDescription:any;
    category:any;
    subCategory:any;
    vendorCompany:any;
    vendorGSTIN:any;
    vendorLocation:any;
    vendorAddress:any;
    status:any;
    otherCategory:any;
    otherSubCategory:any;
    
}